import s from "styled-components";
import Avatar from "_c/Avatar";

export const Wrap = s.li`
 margin-bottom: 30px;
`;
export const Head = s.header`
 z-index: 2;
  padding: 20px;
  border-radius: 9px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  position: relative;
  background-image: var(--grad-primary-n);
  :before {
    content: '';
    position: absolute;
    z-index: 1;
    left: -9px;
    top: 19px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 10px 6px 0;
    border-color: transparent var(--color-primary) transparent transparent;
  }
  time {
   color: white;
   font-weight: 400;
  }
  @media(max-width: 720px) {
    :before {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 6px 10px 6px;
      border-color: transparent transparent var(--color-primary) transparent;
      top: -9px;
      left: 15px;
    }
  }
  @media(max-width: 575px) {
    padding: 35px 15px;
  }
`;
export const HeadMetaGroup = s.div`
  display: flex;
  position: absolute;
  right: 30px;
  bottom: 0;
  transform: translateY(50%);
  @media(max-width: 575px) {
    right: auto;
    left: 15px;
  }
`;
export const ActivityType = s.span`
  display: block;
  color: var(--font-color-emp);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 9px;
  @media(max-width: 720px) {
    margin-left: 50px;
    margin-bottom: 27px;
  }
`;

export const AsideAvatar = s(Avatar)`
  position: absolute;
  left: -60px;
  top: 5px;
  @media(max-width: 720px) {
    top: -55px;
    left: 0;
  }
`;
export const ComponentWrap = s.div`
  position: relative;
  z-index: 1;
`;
